import anime from '@/assets/libs/anime';

export const gridHideInit = (el) => {
  const ctx = el;
  anime.set(ctx, { scaleY: 0, opacity: 0 });
};

export const gridHideAnim = (el, delay) => {
  const ctx = el;
  return anime({
    targets: ctx,
    scaleY: 1,
    opacity: 1,
    duration: 800,
    delay: anime.stagger(150, { start: delay }),
    easing: 'cubicBezier(.5,0,0,1)',
  });
};

export const gridHideOut = (el, delay) => {
  const ctx = el;
  return anime({
    targets: ctx,
    scaleY: 0,
    opacity: 0,
    duration: 800,
    delay: anime.stagger(150, { start: delay }),
    easing: 'cubicBezier(.5,0,0,1)',
  });
};
